module.exports = __webpack_public_path__ + "img/fig31.a0d4efda.jpg";